import React from 'react';

const ConfigDisplay = ({ betBody }) => {
  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(betBody, null, 2));
  };

  return (
    <div className="p-4 mt-6 border border-blue-200 rounded-lg bg-blue-50">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-lg font-semibold text-blue-800">Поточна конфігурація JSON</h3>
        <button
          onClick={copyToClipboard}
          className="px-3 py-1 text-sm font-medium text-blue-700 bg-blue-100 rounded hover:bg-blue-200"
        >
          Копіювати
        </button>
      </div>
      <pre className="p-4 overflow-x-auto text-xs text-gray-800 bg-white border border-blue-200 rounded">
        {JSON.stringify(betBody, null, 2)}
      </pre>
    </div>
  );
};

export default ConfigDisplay;
